module.exports = __webpack_public_path__ + "static/media/magnusson_logo-3.57298101.jpg";